var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3333 18C14.7515 18 18.3333 14.4183 18.3333 10C18.3333 5.58172 14.7515 2 10.3333 2C5.91497 2 2.33325 5.58172 2.33325 10C2.33325 14.4183 5.91497 18 10.3333 18ZM14.0404 9.20711C14.4309 8.81658 14.4309 8.18342 14.0404 7.79289C13.6498 7.40237 13.0167 7.40237 12.6261 7.79289L9.33325 11.0858L8.04036 9.79289C7.64983 9.40237 7.01667 9.40237 6.62615 9.79289C6.23562 10.1834 6.23562 10.8166 6.62615 11.2071L8.62615 13.2071C9.01667 13.5976 9.64983 13.5976 10.0404 13.2071L14.0404 9.20711Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleBlack);
export default __webpack_public_path__ + "static/media/check-circle-black.32589eb60fa06bdfeae5a0fcd5c237b2.svg";
export { ForwardRef as ReactComponent };